export default __webpack_public_path__ + "static/media/music.99616c09.svg";